import { DELETE_JURY_PROFILE_ACTION_TYPE, INSERT_UPDATE_JURY_PROFILE_ACTION_TYPE, JURY_PROFILE_DETAILS_ACTION_TYPE, JURY_PROFILE_LIST_ACTION_TYPE } from "../../utils/constants";
  
  const initialState = [];
  function juryProfileReducer(state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case JURY_PROFILE_LIST_ACTION_TYPE:
        return [...state, payload];
      case JURY_PROFILE_DETAILS_ACTION_TYPE:
        return [...state,payload];
      case DELETE_JURY_PROFILE_ACTION_TYPE:
        return [...state, payload];
      case INSERT_UPDATE_JURY_PROFILE_ACTION_TYPE:
        return [...state, payload];
      default:
        return state;
    }
  }
  export default juryProfileReducer;
  